import Vue from 'vue'
export const EventBus = new Vue() // event bus 在不同組建之間傳遞訊息
